import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { CataleanAuthenticationService, UserSettingsService } from "catalean-authentication";
import { Observable, catchError, switchMap, throwError } from "rxjs";

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
	constructor(private authService: CataleanAuthenticationService, private userSetting: UserSettingsService) {}

	intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
		return next.handle(request).pipe(
			catchError((err) => {
				if (err.status === 401) {
					//if 401 try first to refresh
					return this.authService.tryToRefreshToken().pipe(
						switchMap(() => {
							return next.handle(
								request.clone({
									setHeaders: {
										"Content-Type": "application/json",
										Authorization: "Bearer " + this.authService.idToken,
									},
								})
							);
						}),
						catchError(() => {
							// auto logout if 401 response returned from api
							this.userSetting.resetLoggedUserTokens();
              //this.authService.logout();
							return throwError(() => new Error("unauthorized"));
						})
					);
				}
				return throwError(() => err);
			})
		);
	}
}
